export default "__VITE_ASSET__7eeaa6a6__"